import script from "./QuotationTab.vue?vue&type=script&setup=true&lang=js"
export * from "./QuotationTab.vue?vue&type=script&setup=true&lang=js"

import "./QuotationTab.vue?vue&type=style&index=0&id=3eee9f42&lang=css"

const __exports__ = script;

export default __exports__